module.exports = __webpack_public_path__ + "img/vieus_carre.f1ae4513.jpg";